<div class="layout-footer">
  {{ translateServ.dictionary['RIGHTS_RESERVED'] }} {{ translateServ.dictionary['APP_NAME'] }} ({{ translateServ.dictionary['RIGHTS_RESERVED_YEAR'] }})
  <button
    type="button"
    class="text-primary font-bold hover:underline p-link"
    (click)="sendPostRequest()"
    [disabled]="isLoading"
    aria-label="Send POST request to API"
  >
    Solutions for Now. Success for Tomorrow.
  </button>

  <div *ngIf="isLoading" class="ml-2 text-blue-500">Sending request...</div>
  <div *ngIf="successMessage" class="ml-2 text-green-500">{{ successMessage }}</div>
  <div *ngIf="errorMessage" class="ml-2 text-red-500">{{ errorMessage }}</div>
  <!-- Overlay for big message -->
  <div *ngIf="bigMessage" class="big-message-overlay">
    {{ bigMessage }}
  </div>
</div>
